import { Card, CardContent } from "./ui/card";

const aud = (v) => `A$${Number(v || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const TONES = {
  orange: ["bg-orange-50", "text-orange-700", "text-orange-900"],
  blue: ["bg-blue-50", "text-blue-700", "text-blue-900"],
  purple: ["bg-purple-50", "text-purple-700", "text-purple-900"],
  violet: ["bg-violet-50", "text-violet-700", "text-violet-900"],
  red: ["bg-red-50", "text-red-700", "text-red-900"],
};

function Tile({ tone, title, value, testid, children }) {
  const [bg, fg, strong] = TONES[tone];
  return (
    <Card className={bg} data-testid={`${testid}-card`}>
      <CardContent className="p-4">
        <p className={`text-sm ${fg}`}>{title}</p>
        <p className={`text-xl font-bold ${strong}`} data-testid={testid}>{value}</p>
        <div className={`text-xs ${fg} mt-1 space-y-0.5`}>{children}</div>
      </CardContent>
    </Card>
  );
}

const Line = ({ l, v, testid }) => (
  <div className="flex justify-between gap-2"><span>{l}</span><span data-testid={testid}>{aud(v)}</span></div>
);

export const AuCommissionTiles = ({ s }) => {
  const c = s.commissions || {};
  const plats = Object.entries(c.by_platform || {}).filter(([, p]) => (p.deduction || 0) > 0);
  const of = (cat) => plats.filter(([, p]) => p.category === cat);
  const salesGst = s.share_calculation?.include_gst_in_revenue ? 0 : (s.financial_summary?.sales_gst || 0);
  return (
    <div className="grid md:grid-cols-5 gap-4" data-testid="au-commission-tiles">
      <Tile tone="orange" title="Aggregator Deductions" value={aud(c.aggregator_base_total)} testid="aggregator-deductions-total">
        {of("AGGREGATOR").map(([k, p]) => <Line key={k} l={p.label} v={p.base_deduction} testid={`agg-base-${k}`} />)}
      </Tile>
      <Tile tone="blue" title="Payment Mode Deductions" value={aud(c.payment_mode_base_total)} testid="payment-mode-deductions-total">
        {of("PAYMENT_MODE").map(([k, p]) => <Line key={k} l={`${p.label} base`} v={p.base_deduction} testid={`pm-base-${k}`} />)}
      </Tile>
      <Tile tone="purple" title="Payment Gateway Deductions" value={aud(c.payment_gateway_total)} testid="payment-gateway-deductions-total">
        <div>PG / MDR charges</div>
      </Tile>
      <Tile tone="violet" title="Actual Commission GST" value={aud(c.commission_gst_reported)} testid="commission-gst-total">
        {plats.map(([k, p]) => <Line key={k} l={`${p.label} GST`} v={p.gst_reported} testid={`gst-${k}`} />)}
        <div className="opacity-80">From uploaded files only — no estimates.</div>
      </Tile>
      <Tile tone="red" title="Total Deductions (incl. GST on eligible sales)" value={aud(s.share_calculation?.total_deductions)} testid="commissions-total-deductions">
        <div data-testid="commissions-total-deductions-trace">
          = {aud(c.aggregator_base_total)} + {aud(c.payment_mode_base_total)} + {aud(c.payment_gateway_total)} + {aud(c.commission_gst_reported)} + GST on sales {aud(salesGst)}
        </div>
        {c.payout_reconciliation_difference > 0 && (
          <div className="pt-1 font-semibold text-amber-700" data-testid="payout-reconciliation-difference">
            vs platform payouts: +{aud(c.payout_reconciliation_difference)} (reported GST inside included fees, added once on top)
          </div>
        )}
        {c.needs_reconciliation && <div className="font-semibold text-amber-700" data-testid="commissions-needs-reconciliation">Needs reconciliation — see row status</div>}
      </Tile>
    </div>
  );
};
